import React from 'react';
import { BrandColor } from '@styleseat/brand';
import { ModalBox } from '../../ui';
import PortalOverlay, { PortalOverlayModal } from '../../ui/PortalOverlay';
import { RateThisApp } from './RateThisApp';

export const RateThisAppModal = ({
  onClose,
}: {
  onClose: (dismiss: boolean) => void;
}) => (
  <PortalOverlay
    onBackdropClick={() => onClose(false)}
    name="client-booking-survey"
  >
    <PortalOverlayModal position="menu">
      <ModalBox scrollable color={BrandColor.BoneLight} padding={0}>
        <RateThisApp
          onClose={() => onClose(false)}
          onPositiveClick={() => onClose(true)}
          onNegativeClick={() => onClose(false)}
        />
      </ModalBox>
    </PortalOverlayModal>
  </PortalOverlay>
);
